import { createAction } from '@reduxjs/toolkit';

export interface IModalOpenSharePayload {
  payload: {
    open: boolean,
  },
}

export const setOpenShare = createAction('share/SET_OPEN', (open = true): IModalOpenSharePayload => ({
  payload: {
    open,
  },
}));
